import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TemplateArea } from '../model/template-area';
import { Document } from '../model/document';
import { MatCheckboxChange as MatCheckboxChange } from '@angular/material/checkbox';
import { TemplateAttributeMode } from '../model/template-attribute-mode.enum';
import { TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-template-area',
    templateUrl: './area.component.html',
    styleUrls: ['./area.component.scss'],
    standalone: false
})
export class AreaComponent implements OnInit {

  @Input() templateArea: TemplateArea;
  @Input() document: Document;
  @Input() form: FormGroup;
  @Input() metaData: any;

  constructor(public translationService: TranslationService) { }

  ngOnInit() {

  }

  public choiceCheckboxChanged(value: MatCheckboxChange) {

    // gewählte Choice immer auf true setzen, deselektieren ist so nicht möglich
    this.templateArea.choiceAttribute.choiceSelected = true;
    this.form.controls[this.templateArea.choiceAttribute.key].setValue(true);
    // alle attribute des Choice aktivivieren
    for (const childAttribute of this.templateArea.attributes) {
      if (childAttribute.mode !== TemplateAttributeMode.DISABLED) {
        const childCtrl = this.form.controls[childAttribute.key];
        childCtrl.enable();
      }
    }

    for (const area of this.document.template.areas) {
      // alle TemplateAreas mit gleichem Choice deaktivieren
      if (area.choice === this.templateArea.choice && this.templateArea.uuid !== area.uuid) {
        const ctrl = this.form.controls[area.choiceAttribute.key];
        if (ctrl != null) {
          area.choiceAttribute.choiceSelected = false;
          ctrl.setValue(false);
          // alle attribute inaktiven Choice deaktivivieren um validierung zu umgehen
          for (const childAttribute of area.attributes) {
            if (childAttribute.mode !== TemplateAttributeMode.DISABLED) {
              const childCtrl = this.form.controls[childAttribute.key];
              childCtrl.disable();
            }
          }
        }
      }

    }
  }

  public isChoiceChecked(): boolean {
    const ctrl = this.form.controls[this.templateArea.choiceAttribute.key];
    return ctrl != null && ctrl.value;
  }
}
